import { ConnectionsListFormPayload, ConnectionsListWebPage } from 'bank-connections/src/routes/ConnectionsList/types'
import { Request } from 'commons/utils/request'
import { WriteHook, useMutationManager } from 'state-manager'

export const useGetConnectionsWebPage: WriteHook<ConnectionsListFormPayload, ConnectionsListWebPage> = (payload) =>
  useMutationManager((filter) => Request.post(Request.urls.bank.connectionsListWebpages, { ...filter }), payload)
